import { render, staticRenderFns } from "./dev-header-dashboard.vue?vue&type=template&id=7ea2add8&scoped=true"
import script from "./dev-header-dashboard.vue?vue&type=script&lang=js"
export * from "./dev-header-dashboard.vue?vue&type=script&lang=js"
import style0 from "./dev-header-dashboard.vue?vue&type=style&index=0&id=7ea2add8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ea2add8",
  null
  
)

export default component.exports